export interface ApiState {
  show: boolean;
  errorMessage: string[] | null;
  errorConfirmCallback: (() => void) | null;
}

export const initialState: ApiState = {
  show: false,
  errorMessage: null,
  errorConfirmCallback: null,
};

export interface FormErrorResponse {
  type: string;
  errors: FormErrors[];
}

export interface FormErrors {
  attr: string | null;
  code: string | null;
  detail: string | null;
}
